<template>
  <div :style="css" class="py-10 py-sm-12 py-md-14 py-lg-16">
    <Loading v-if="loading" />

    <v-container v-else>
      <PagesTitle logoHeight="24px" :mod="mod">Exames Realizados</PagesTitle>

      <v-row justify="center" class="mt-4">
        <v-col
          class="mt-4"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="({ img, title, text }, keyItems) in items"
          :key="keyItems"
        >
          <div class="d-flex flex-column item">
            <v-sheet
              v-if="img"
              class="
                d-flex
                align-center
                justify-center
                rounded-circle
                pa-7
                mx-auto
                item-icon
              "
              width="150px"
              height="150px"
            >
              <img :src="files + img" :alt="title" class="d-block" />
            </v-sheet>
            <div class="service-caption">
              <div
                v-if="title"
                class="
                  text-h5 text-md-h4 text-center
                  font-weight-bold
                  px-3
                  mt-6
                  item-title
                "
              >
                {{ title }}
              </div>

              <div
                v-html="text"
                class="
                  secondary--text
                  text--lighten-3 text-center
                  mt-4
                  item-text
                "
              ></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PagesTitle from "../widgets/PagesTitle.vue";
import Loading from "../widgets/Loading.vue";

const _config = {
  mod: "pages-exams",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    loading: true,
    items: [],
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.items = data),
      })
      .then(() => (this.loading = false));
  },
  computed: {
    css() {
      return {
        "--page-color": this.color,
      };
    },
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.service-caption {
  height: 350px;
  @media (max-width: 600px) {
    height: 250px;
  }
}
.item {
  height: 100%;
  .item-icon {
    background-color: var(--page-color);
    img {
      object-fit: contain;
      max-height: 100%;
      width: 100%;
    }
  }
  .item-title {
    color: var(--page-color);
  }
}
</style>
